import React, { useEffect } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Home, ICourseInfo } from './Home';
import { Course } from './Course';
import { UI } from './UI';

const history = createBrowserHistory();

declare global {
  interface Window { 
    courses: ICourseInfo[];
    grecaptcha_token: string;
    ga: any;
    setToken(token:any):void;
  }
}

history.listen((location) => {
  window.ga('set', 'page', location.pathname + location.search);
  window.ga('send', 'pageview');
});

export default function App() {
  return (
    <Router history={history}>
      <Switch>
        <Route path="/course/:id">
          <Course />
        </Route>
        <Route path="/tutorial/:id">
          <Course />
        </Route>
        <Route path="/ui">
          <UI />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}
